<template>
    <div class="col-12">
        <div class="form__item">
            <div class="form__item__label form__item__label--required">{{title}}</div>
            <div class="form__item__input-wrapper">
                <input
                    type="text"
                    v-model="valEdit"
                    class="input_n"
                    :class="{input_red_shadow: showError}"
                    :disabled="disabledFlag"
                >
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CustomTextInput',
        data() {
            return {
                valEdit: this.val
            }
        },
        props: {
            title: {
                type: String,
            },
            val: {
              required: true,
            },
            showError: {
                type: Boolean,
                default: false,
            },
            disabledFlag: {
                type: Boolean,
                default: false,
            },
        },
        watch: {
          valEdit: function(newVal, oldVal) {
            this.$emit('update:val', newVal);
          },
          val() {
            this.valEdit = this.val;
          }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Garantie/DealerInsuranceCampingCar/CustomTextInput.vue